module.exports = __webpack_public_path__ + "img/3c-store.7461c6b5.png";